export const attachments_url = "/api/storage/app/public/chat_attachments/";
export const profile_url = "https://hrm.arcinventador.com/public/img/";
